import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';
import styles from './ls-field.module.scss';

type BaseProps = {
  label: string;
  error?: string;
  isMultiline?: boolean;
};

type Props = BaseProps &
  InputHTMLAttributes<HTMLInputElement> &
  TextareaHTMLAttributes<HTMLTextAreaElement>;

export function LsField({ label, error, isMultiline, id, ...rest }: Props) {
  const fieldId = id ?? `ls-field-${label.replace(/\s+/g, '-').toLowerCase()}`;
  const errorId = `${fieldId}-error`;

  return (
    <div className={styles['ls-field']}>
      <label className={styles['ls-field__label']} htmlFor={fieldId}>
        {label}
      </label>

      {isMultiline ? (
        <textarea
          className={`${styles['ls-field__control']} ${styles['ls-field__control--is-multiline']}`}
          id={fieldId}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          {...rest}
        />
      ) : (
        <input
          className={styles['ls-field__control']}
          id={fieldId}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          {...rest}
        />
      )}

      {error && (
        <p className={styles['ls-field__error']} id={errorId} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
